import type { AccountSnapshot } from '@/utils/performanceData';
import { formatIsoDate } from '@/utils/numberFormat';

interface DataFreshnessProps {
  snapshot: AccountSnapshot;
}

/**
 * A slim trust strip above the headline statistics. It makes the "live account"
 * claim concrete by showing exactly when the account data was last updated and
 * which account number it belongs to.
 */
export default function DataFreshness({ snapshot }: DataFreshnessProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
      <div className="flex items-center gap-2.5">
        <span className="relative flex h-2.5 w-2.5" aria-hidden="true">
          <span className="absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-70 animate-ping"></span>
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500"></span>
        </span>
        <span className="text-xs md:text-sm font-semibold text-foreground-900">
          Live account data
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] md:text-xs text-foreground-600">
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-refresh-line text-primary-600" aria-hidden="true"></i>
          Updated {formatIsoDate(snapshot.updatedAt)}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-hashtag" aria-hidden="true"></i>
          #{snapshot.accountNumber}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-exchange-line" aria-hidden="true"></i>
          {snapshot.totalTrades} trades
        </span>
      </div>
    </div>
  );
}